import { createHead } from '@unhead/vue'

const head = createHead()

export default head
